import { render, staticRenderFns } from "./mic_input.vue?vue&type=template&id=4e2878b0&scoped=true&"
import script from "./mic_input.vue?vue&type=script&lang=js&"
export * from "./mic_input.vue?vue&type=script&lang=js&"
import style0 from "./mic_input.vue?vue&type=style&index=0&id=4e2878b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2878b0",
  null
  
)

export default component.exports